import { createTheme } from '@mui/material/styles';
import * as index from './overrides/index.js';
import basicTheme from './basicTheme.js';

const theme = createTheme({
    components: Object.assign({ MuiCircularProgress: {
            defaultProps: {
                thickness: 5,
            },
        } }, index),
}, basicTheme);

export { theme as default };
//# sourceMappingURL=theme.js.map
